<template>
  <div class="fill-width">
    <div v-if="!!label" class="text-body-2 mb-1">{{ label }}</div>
    <v-file-input
      counter
      v-model="value"
      show-size
      chips
      truncate-length="15"
      :multiple="multiple"
      :outlined="outlined"
      :rounded="rounded"
      :dense="dense"
      :accept="accept"
      @change="onFileChange"
    >
      <template v-slot:selection="{ text }">
        <v-chip small color="success">
          {{ text }}
        </v-chip>
      </template>
    </v-file-input>
  </div>
</template>
<script>
export default {
  name: "CustomFileInput",
  props: {
    label: {
      type: String,
      required: false,
    },
    outlined: {
      Type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
      default: "",
    },
    currentValue: null,
  },
  beforeMount() {
    if (this.currentValue) this.value = this.currentValue;
  },
  data() {
    return {
      value: null,
    };
  },
  methods: {
    onFileChange() {
      this.$emit("selectedFile", this.value);
    },
    removeItem() {
      console.info("click");
    },
  },
};
</script>
<style scoped></style>
